import Path from '@leverege/path';
function getAccess(lookupItem) {
  let accessor;
  if (typeof lookupItem === 'object') {
    accessor = lookupItem.accessor;
  } else {
    accessor = lookupItem;
  }
  if (typeof accessor === 'string') {
    return Path(accessor).get;
  }
  return accessor;
}

// borrowed from react-table: https://github.com/tannerlinsley/react-table/blob/0c805a774f7a432f31b4aeeab5820b2f8e1ce395/src/publicUtils.js#L216
function isReactComponent(component) {
  return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
}
function isClassComponent(component) {
  return typeof component === 'function' && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}
function isExoticComponent(component) {
  return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
}
export { getAccess, isReactComponent };